module.exports = __webpack_public_path__ + "img/sample-report-14@3x.464fccdd.png";